import util from '@/libs/util'
import qs from 'qs'
import md5 from 'js-md5'
import store from '../store'
import { Notification } from 'element-ui'
let api = {}

export default api

api.QUERY_USER_INFO = '/jpcp/ssoUser/userInfo'
api.queryGridConfigUrl = '/superAdmin/gridManage/queryGridConfig'
api.SUPER_ADMIN_GRID_MANAGE_QUERY_COLUMNS = '/superAdmin/gridManage/queryGridColumnConfig'
api.SUPER_ADMIN_GRID_MANAGE_SAVE_COLUMN = '/superAdmin/gridManage/saveSingleColumn'
api.SUPER_ADMIN_GRID_MANAGE_DELETE_COLUMN = '/superAdmin/gridManage/deleteGridColumn'
api.SUPER_ADMIN_GRID_MANAGE_GET_ENUMCONSTS = '/superAdmin/gridManage/getEnumConstsByNamespace'
api.QUERY_SITE_DETAIL_INFO = '/open/site/info'
api.SUPER_ADMIN_SITE_MANAGE_CONFIG_URL = '/superAdmin/siteManage/abstractGrid'

/**
 * 查询当前用户信息
 * @param data
 * @returns {*}
 */
api.queryUserInfo = function (data) {
  return util.ajax({
    url: api.QUERY_USER_INFO,
    method: 'post',
    data: qs.stringify({
      client_id: store.state.app.client_id
    })
  })
}

/**
 * 查询列表列配置列表
 * @param data
 * @returns {*}
 */
api.queryGridColumnConfigs = function (data) {
  return util.ajax({
    url: api.SUPER_ADMIN_GRID_MANAGE_QUERY_COLUMNS,
    method: 'post',
    data
  })
}

/**
 * 保存grid列配置
 * @param data
 * @returns {*}
 */
api.saveGridColumnConfig = function (data) {
  return util.ajax({
    url: api.SUPER_ADMIN_GRID_MANAGE_SAVE_COLUMN,
    method: 'post',
    data
  })
}

/**
 * 删除grid列配置
 * @param data
 * @returns {*}
 */
api.deleteGridColumnConfig = function (data) {
  return util.ajax({
    url: api.SUPER_ADMIN_GRID_MANAGE_DELETE_COLUMN,
    method: 'post',
    data
  })
}

/**
 * 常量查询
 * @param data
 * @returns {*}
 */
api.getEnumConstsByNamespace = function (data) {
  return util.ajax({
    url: api.SUPER_ADMIN_GRID_MANAGE_GET_ENUMCONSTS,
    method: 'post',
    data
  })
}

/**
 * 查询当前站点初始化的信息
 * @param data
 * @returns {*}
 */
api.querySiteDetailInfo = function (data) {
  return util.ajax({
    url: api.QUERY_SITE_DETAIL_INFO,
    method: 'post',
    data: qs.stringify({
      client_id: store.state.app.client_id
    })
  })
}

api.getToken = function(form) {
  const useSso = store.state.app.useSso
  if (useSso) {
    const ssoBasePath = store.state.app.ssoBasePath
    if (!ssoBasePath) {
      Notification.error('请先联系管理员配置用户中心！')
      return false
    }
    return util.ajax.post(ssoBasePath + '/oauth/access_token', qs.stringify({
      username: form.userName,
      password: form.password,
      client_id: store.state.app.client_id
    }), {
      validateStatus: function (status) {
        return status >= 200 && status <= 400
      }
    })
  } else {
    return util.ajax.post('/oauth/token', qs.stringify({
      username: form.userName,
      password: md5(form.password),
      grant_type: 'password',
      client_id: store.state.app.client_id
    }), {
      validateStatus: function (status) {
        return status >= 200 && status <= 400
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/config/api.js